import React from 'react';
import Svg from '../Svg';
import { SvgProps } from '../types';

const Icon: React.FC<SvgProps> = props => (
  <Svg viewBox="0 0 15 16" {...props}>
    <path
      d="M13.8123 2.5998H0.587368C0.263368 2.5998 0 2.84157 0 3.1398C0 3.43803 0.263368 3.6798 0.587748 3.6798H13.8126C14.1366 3.6798 14.4 3.43803 14.4 3.1398C14.4 2.84157 14.1366 2.5998 13.8123 2.5998ZM9.35999 12.5172V6.00238C9.35999 5.81556 9.25692 5.64314 9.09018 5.54991C8.92229 5.45655 8.71807 5.45655 8.55018 5.54991C8.38307 5.64314 8.27999 5.81556 8.27999 6.00238V12.5172C8.27999 12.806 8.52176 13.0398 8.81999 13.0398C9.11823 13.0398 9.35999 12.806 9.35999 12.5172ZM12.3738 4.76094C12.0964 4.76246 11.8591 4.94284 11.8072 5.1918H11.7959V13.6931C11.7978 13.8064 11.75 13.9152 11.6632 13.9963C11.5772 14.077 11.459 14.1228 11.3354 14.1243H3.4268C3.16609 14.1236 2.95463 13.9311 2.95312 13.6931V5.1918H2.94289C2.89286 4.94208 2.65489 4.76056 2.37712 4.76056C2.09897 4.76056 1.86099 4.94208 1.81097 5.1918H1.79993V14.5545C1.79771 14.7235 1.86895 14.8868 1.99855 15.0077C2.12777 15.1289 2.30474 15.1979 2.49004 15.1998H12.2601C12.647 15.196 12.9588 14.9088 12.96 14.5556V5.1903H12.9486C12.8906 4.94247 12.6511 4.76474 12.3737 4.7636V4.75944V4.76057L12.3738 4.76094ZM4.92403 1.8798H9.47367C9.80866 1.8798 10.08 1.63804 10.08 1.3398C10.08 1.04157 9.80866 0.799805 9.47367 0.799805H4.92631C4.59132 0.799805 4.31999 1.04157 4.31999 1.3398C4.31999 1.63804 4.59132 1.8798 4.92631 1.8798H4.92404H4.92403ZM6.11999 12.5066V6.0107C6.11847 5.71816 5.87519 5.48131 5.57507 5.4798C5.27645 5.48321 5.03696 5.72119 5.03999 6.01184V12.5078C5.03734 12.7984 5.27645 13.0364 5.57507 13.0398C5.87595 13.0383 6.11961 12.8003 6.11999 12.5066Z"
      fill="url(#paint0_linear_7873_37545)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7873_37545"
        x1="9.69567"
        y1="15.1998"
        x2="4.70433"
        y2="0.799805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FE3876" stopOpacity="0.519832" />
        <stop offset="1" stopColor="#D030DD" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Icon;
